import { Flex, GapSize } from "@/components/atoms/flex";
import { AttachmentList } from "@/components/atoms/attachment";
import { EmailThreadSortButton, EmailThreadSortOrder } from "@/components/molecules/email";
import { formatDate } from "@/common/helpers/dateHelper";
import { Message } from "@/repository/models/message";
import { Text } from "@fluentui/react-components";
import { useIntl } from "react-intl";
import { useEmailConversationHeaderStyles } from "./style";

interface EmailConversationHeaderProps {
	messages: Message[] | undefined;
	sessionId: string;
	isHistory: boolean;
	isPreview: boolean;
	sortOrder: EmailThreadSortOrder;
	onSortChange: (order: EmailThreadSortOrder) => void;
	draftSubject?: string;
}

export const EmailConversationHeader = ({
	messages,
	sessionId,
	isHistory,
	isPreview,
	sortOrder,
	onSortChange,
	draftSubject,
}: EmailConversationHeaderProps) => {
	const classes = useEmailConversationHeaderStyles();
	const intl = useIntl();
	const messagesList = messages ?? [];
	const subject = messagesList.find((x) => !!x.subject)?.subject ?? draftSubject;
	const allAttachments = messagesList
		.flatMap((x) => x.attachments?.map((a) => ({ messageId: x.id, ...a })))
		.filter((x) => !x.isInline);

	return (
		<Flex hAlign="space-between" vAlign="center" className={classes.header}>
			<Flex vAlign="baseline" gap={GapSize.Small} className={classes.subjectBlock}>
				<Text size={400} weight="semibold" className={classes.subjectLabel}>
					{`${intl.formatMessage({
						id: "Interaction.EmailEditor.SubjectLabel",
					})}:`}
				</Text>
				<Text size={400} weight="semibold" truncate wrap={false}>
					{subject}
				</Text>
			</Flex>
			<Flex vAlign="center">
				{!!allAttachments.length && (
					<AttachmentList
						sessionId={sessionId}
						isHistory={isHistory}
						isPreview={isPreview}
						items={allAttachments.map((x) => ({
							id: x.id,
							name: x.name,
							messageId: x.messageId,
							contentType: x.contentType,
							date: formatDate(new Date(Date.parse(x.lastModifiedDateTime))),
							size: x.size,
						}))}
					/>
				)}
				{!isPreview && (
					<EmailThreadSortButton sortOrder={sortOrder} onChange={onSortChange} />
				)}
			</Flex>
		</Flex>
	);
};
